export default __webpack_public_path__ + "static/media/bg-categories-1.5af4685f.png";